export default __webpack_public_path__ + "static/media/property_717.f625ce99.png";